import VirtualWaitingRoom from './VirtualWaitingRoom';
export default VirtualWaitingRoom;
